import * as ls from 'local-storage';

const profile = {
	namespaced: true,
	state: {
		meal_preferences: {
			excluded_groups: [],
			meal_plan: null,
			people: 1,
			shipping_date: null
		},
		user: {
			first_name: '',
			last_name: '',
			email: '',
			postcode: ''
		}
	},
	mutations: {
		updateMealPreferences(state, data) {
			state.meal_preferences.meal_plan = data.plan;
			if (data.plan == "Plant-Based") {
				state.meal_preferences.excluded_groups = ["Beef", "Chicken", "Fish", "Lamb", "Pork", "Shellfish"]
			} else if (data.plan == "Pescatarian") {
				state.meal_preferences.excluded_groups = ["Chicken", "Lamb", "Pork", "Beef"];
			} else {
				state.meal_preferences.excluded_groups = data.groups;
			}
		},
		updateName(state, data) {
			state.user.first_name = data.first_name;
			state.user.last_name = data.last_name;
		},
		updateEmailAddress(state, data) {
			state.user.email = data;
		},
		updatePostCode(state, data) {
			state.user.postcode = data;
		},
		updatePeoplePreferences(state, data) {
			state.meal_preferences.people = data;
		},
		updatePrefferedShippingDate(state, data) {
			state.meal_preferences.shipping_date = data;
		},
		loadProfile(state) {
			state.meal_preferences.excluded_groups = ls.get('meal_preferences.excluded_groups');
			state.meal_preferences.meal_plan = ls.get('meal_preferences.meal_plan');
			state.meal_preferences.people = ls.get('meal_preferences.people') || 1;
			state.meal_preferences.shipping_date = ls.get('meal_preferences.shipping_date');
			state.user.first_name = ls.get('user.first_name');
			state.user.last_name = ls.get('user.last_name');
			state.user.email = ls.get('user.email');
			state.user.postcode = ls.get('user.postcode');
		},
		storeProfile(state) {
			if (state.meal_preferences.excluded_groups != null)
				ls.set('meal_preferences.excluded_groups', state.meal_preferences.excluded_groups);
			if (state.meal_preferences.meal_plan != null)
				ls.set('meal_preferences.meal_plan', state.meal_preferences.meal_plan);
			if (state.meal_preferences.meal_plan != null)
				ls.set('meal_preferences.people', state.meal_preferences.people);
			if (state.meal_preferences.shipping_date != undefined)
				ls.set('meal_preferences.shipping_date', state.meal_preferences.shipping_date);
			if (state.user.first_name != null)
				ls.set('user.first_name', state.user.first_name);
			if (state.user.last_name != null)
				ls.set('user.last_name', state.user.last_name);
			if (state.user.email != null)
				ls.set('user.email', state.user.email);
			if (state.user.postcode != null)
				ls.set('user.postcode', state.user.postcode);
		},
		setShippingDate(state, value) {
			state.meal_preferences.shipping_date = value;
		}
	},
	actions: {
		updateMealPreferences({ commit, dispatch }, value) {
			commit('updateMealPreferences', value);
			commit('storeProfile');
			dispatch(`analytics/setGAMealPlan`, value.plan ? value.plan.toLowerCase() : 'all', { root: true });
		},
		updatePeoplePreferences({ commit, dispatch }, value) {
			commit('updatePeoplePreferences', value);
			dispatch(`basket/configure`, { people: value }, { root: true });
			dispatch(`basket/updateBasketItemPortions`, value, { root: true });
			dispatch(`basket/updateDiscount`, null, { root: true });
			commit('storeProfile');
			dispatch(`analytics/setGAPeople`, value, { root: true });
		},
		updatePrefferedShippingDate({ commit, dispatch }, value) {
			dispatch(`basket/emptyBasket`, null, { root: true });
			commit('updatePrefferedShippingDate', value);
			commit('storeProfile');
		},
		updateEmailAddress({ commit }, value) {
			commit('updateEmailAddress', value);
			commit('storeProfile');
		},
		updateName({ commit }, value) {
			commit('updateName', value);
			commit('storeProfile');
		},
		updatePostCode({ commit }, value) {
			commit('updatePostCode', value);
			commit('storeProfile');
		},
		storeProfile({ commit }) {
			commit('storeProfile');
		},
		loadProfile({ commit, dispatch, state }) {
			commit('loadProfile');
			dispatch(`basket/configure`, { people: ls.get('meal_preferences.people') || 1 }, { root: true });
			return state;
		},
		validateCurrentShippingDate({ dispatch }, data) {
			dispatch(`recipes/validateShippingRun`, data.available_dates, { root: true });
		},
		validateProfile({ dispatch }, dates) {
			// dispatch('validateCurrentShippingDate', dates);
		},
		setShippingDate({ commit }, value) {
			commit("setShippingDate", value);
			commit('storeProfile');
		}
	}
};
//
export default profile;